import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Box, Stack, TextField } from "@mui/material";
import Wrapper from "../wrappers/Wrapper";
import MyLoadingButton from "../buttons/MyLoadingButton";
import UserHint from "../display/UserHint";
import useSubmit from "../../features/master/species/hooks/useSubmit";

export default function TitleWithTranslationForm({
  apiPath,
  refetch,
  queryKey,
  invalidateQueries = [],
  placeHolder,
  controllerName = "title",
  permissions = [],
  hint = null,
  id = null,
  maxLength = 255,
}) {
  const { t, i18n } = useTranslation();
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useFormContext();

  const { loading, submitCallback } = useSubmit(null, apiPath, queryKey, invalidateQueries);
  const currentLanguage = i18n.language;

  const submitData = async (data) => {
    const obj = {
      ...data,
      translations: {
        [currentLanguage]: data?.title,
      },
    };
    await submitCallback(obj);
    reset();
    refetch?.();
  };

  return (
    <form onSubmit={handleSubmit(submitData)}>
      <Stack mb={2} mt={2}>
        <Wrapper>
          <Controller
            name={controllerName}
            defaultValue={""}
            control={control}
            rules={{ required: t("CantBeEmpty") }}
            render={({ field }) => (
              <TextField
                {...field}
                label={t(placeHolder)}
                fullWidth
                sx={{ p: 1 }}
                variant="standard"
                error={!!errors?.title}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: maxLength }}
                helperText={errors?.title ? errors?.title?.message : ""}
              />
            )}
          />
          <Box sx={{ ml: 2 }}>
            <MyLoadingButton
              message={t("Add")}
              isLoading={loading}
              permissions={permissions}
            />
          </Box>
        </Wrapper>
        <UserHint hint={hint} />
      </Stack>
    </form>
  );
}